const FRENCH_MONTHS = {
  janvier: 0,
  fevrier: 1,
  février: 1,
  mars: 2,
  avril: 3,
  mai: 4,
  juin: 5,
  juillet: 6,
  aout: 7,
  août: 7,
  septembre: 8,
  octobre: 9,
  novembre: 10,
  decembre: 11,
  décembre: 11,
};

/** Parse French session labels like "Janvier 2026" or "27-28 Novembre 2026". */
export function parseSessionDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null;

  const normalized = dateStr
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const monthYear = normalized.match(/^([a-z]+)\s+(\d{4})$/);
  if (monthYear) {
    const month = FRENCH_MONTHS[monthYear[1]];
    if (month == null) return null;
    return new Date(Number(monthYear[2]), month, 1);
  }

  const rangeMatch = normalized.match(/(\d{1,2})(?:-\d{1,2})?\s+([a-z]+)\s+(\d{4})/);
  if (rangeMatch) {
    const month = FRENCH_MONTHS[rangeMatch[2]];
    if (month == null) return null;
    return new Date(Number(rangeMatch[3]), month, Number(rangeMatch[1]));
  }

  return null;
}

/** True when the session end is before today (start of local day). */
export function isSessionPast(dateStr, now = new Date()) {
  const parsed = parseSessionDate(dateStr);
  if (!parsed) return false;

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return parsed < today;
}

export function filterUpcomingSessions(sessions, now = new Date()) {
  if (!Array.isArray(sessions)) return [];
  return sessions.filter((session) => !isSessionPast(session?.date, now));
}
